import type { Engine } from "tsparticles-engine";
import type { IParticlesProps } from "react-tsparticles";
import ReactParticles from "react-tsparticles";
import { loadFull } from "tsparticles";
import React, { useCallback } from "react";

export const Particles = ({
  canvasClassName,
  className,
  options,
  id = "tsparticles",
}: IParticlesProps): React.ReactElement => {
  const customInit = useCallback(async (engine: Engine) => {
    await loadFull(engine);
  }, []);

  return (
    <ReactParticles
      id={id}
      style={{ position: "relative" }}
      canvasClassName={canvasClassName}
      className={className}
      init={customInit}
      options={{
        fullScreen: false,
        background: {
          color: {
            value: "#000",
          },
        },
        fpsLimit: 30,
        interactivity: {
          detectsOn: "canvas",
          events: {
            onClick: {
              enable: false,
              mode: "push",
            },
            onHover: {
              enable: false,
              mode: "repulse",
            },
            resize: true,
          },
          modes: {
            bubble: {
              distance: 40,
              duration: 2,
              opacity: 0.8,
              size: 80,
            },
            push: {
              quantity: 4,
            },
            repulse: {
              distance: 200,
              duration: 0.4,
            },
          },
        },
        particles: {
          color: {
            value: "#fefefe80",
          },
          links: {
            color: "#fefefe80",
            distance: 150,
            enable: true,
            opacity: 0.5,
            width: 1,
          },
          collisions: {
            enable: true,
          },
          move: {
            direction: "none",
            enable: true,
            outMode: "out",
            random: false,
            speed: 1.2,
            straight: false,
            attract: {
              enable: false,
              rotateX: 600,
              rotateY: 600,
            },
          },
          number: {
            density: {
              enable: true,
              value_area: 900,
            },
            value: 50,
          },
          opacity: {
            value: 0.2,
            anim: {
              enable: false,
              speed: 1,
              opacity_min: 0.1,
              sync: false,
            },
          },
          shape: {
            type: "circle",
            stroke: {
              width: 0,
              color: "#fefefe80",
            },
            polygon: {
              nb_sides: 5,
            },
            image: {
              src: "img/github.svg",
              width: 100,
              height: 100,
            },
          },
          size: {
            random: true,
            value: 2,
            anim: {
              enable: false,
              speed: 9.59040959040959,
              size_min: 5.594405594405594,
              sync: false,
            },
          },
        },
        detectRetina: true,
        ...options,
      }}
    />
  );
};
